module.exports = __webpack_public_path__ + "static/img/s_logo.3004333.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s_logo.png
// module id = Fbja
// module chunks = 26